import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AdsterraAdvertise from "../Adsterra/AdsterraAdvertise";

const Home = () => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingDone, setLoadingDone] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingProgress((prev) => {
        const next = prev + 1;

        if (next >= 100) {
          clearInterval(interval);
          setLoadingDone(true);
        }

        return next;
      });
    }, 42);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">

      {/* Header */}
      <nav className="navbar navbar-expand-lg custom-navbar px-3 px-lg-5">

        <div className="container-fluid">

          <a
            className="navbar-brand d-flex align-items-center gap-3"
            href="/"
          >
            <img
              src="../images/app-icon/ImageA.png"
              alt="Chess Master"
              className="nav-logo"
            />

            <div>
              <h2 className="brand-title mb-0">
                Chess Master
              </h2>

              <p className="brand-subtitle mb-0">
                Master Every Move ♟️
              </p>
            </div>
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarMenu"
          >

            <ul className="navbar-nav gap-lg-4 text-center mt-4 mt-lg-0">

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Features
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Matches
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Contact
                </a>
              </li>

            </ul>

          </div>

        </div>

      </nav>

      {!loadingDone ? (

        /* Splash Screen */
        <div className="splash-screen">

          <img
            src="../images/app-icon/ImageA.png"
            alt="Chess Master Logo"
            className="logo"
          />

          <h1 className="title">
            Chess Master
          </h1>

          <div className="loading-bar-container">

            <div
              className="loading-bar-fill"
              style={{ width: `${loadingProgress}%` }}
            ></div>

          </div>

          <p className="loading-text">
            {loadingProgress}%
          </p>

        </div>

      ) : (

        <>
          {/* Main Content */}
          <main className="main-content">

            {/* Hero */}
            <section className="hero-section text-center">

              <h1 className="hero-title">
                Chess Master ♟️
              </h1>

              <p className="hero-subtitle">
                Improve your strategy, challenge powerful opponents,
                and become a true chess champion.
              </p>

            </section>

            {/* About Chess */}
            <section className="info-section">

              <div className="section-card">

                <h2 className="section-title">
                  About Chess
                </h2>

                <p className="section-text">

                  Chess is one of the most popular strategy games in the world.
                  It helps improve
                  <strong className="highlight">
                    {" "}concentration
                  </strong>,
                  <strong className="highlight">
                    {" "}logical thinking
                  </strong>,
                  <strong className="highlight">
                    {" "}planning
                  </strong>, and
                  <strong className="highlight">
                    {" "}problem solving skills
                  </strong>.

                  Every move matters, and every game teaches new strategies.
                  Whether you are a beginner or an advanced player,
                  chess is the perfect game to sharpen your mind and
                  challenge yourself.

                </p>

              </div>

            </section>

            {/* Features */}
            <section className="features-section">

              <div className="row g-4">

                {/* Player vs Player */}
                <div className="col-lg-4 col-md-6">

                  <div className="feature-card">

                    <div className="feature-icon">
                      <i className="fas fa-users"></i>
                    </div>

                    <h3 className="feature-title">
                      Player vs Player
                    </h3>

                    <p className="feature-text">

                      Play locally with your friends and enjoy
                      <strong>
                        {" "}real-time multiplayer battles
                      </strong>
                      {" "}on the same device.

                    </p>

                  </div>

                </div>

                {/* Player vs Computer */}
                <div className="col-lg-4 col-md-6">

                  <div className="feature-card">

                    <div className="feature-icon">
                      <i className="fas fa-robot"></i>
                    </div>

                    <h3 className="feature-title">
                      Player vs Computer
                    </h3>

                    <p className="feature-text">

                      Challenge smart AI opponents and improve your
                      <strong>
                        {" "}strategy and gameplay skills
                      </strong>
                      {" "}with different difficulty levels.

                    </p>

                  </div>

                </div>

                {/* Online Match */}
                <div className="col-lg-4 col-md-12">

                  <div className="feature-card">

                    <div className="feature-icon">
                      <i className="fas fa-globe"></i>
                    </div>

                    <h3 className="feature-title">
                      Online Match
                    </h3>

                    <p className="feature-text">

                      Compete against players worldwide and test your
                      <strong>
                        {" "}chess mastery online
                      </strong>.
                      Coming soon with exciting multiplayer features.

                    </p>

                  </div>

                </div>

              </div>

            </section>

            {/* Advertisement */}
            <section className="board-section">

              <div className="ad-box">
                <AdsterraAdvertise />
              </div>

            </section>

          </main>

          {/* Footer */}
          <footer className="custom-footer">

            <div className="container">

              <div className="row gy-4">

                <div className="col-lg-4">

                  <div className="d-flex align-items-center gap-3 mb-4">

                    <img
                      src="../images/app-icon/ImageA.png"
                      alt="Chess Master"
                      className="footer-logo"
                    />

                    <div>

                      <h3 className="footer-title mb-1">
                        Chess Master
                      </h3>

                      <p className="footer-subtitle mb-0">
                        Smart Chess Experience
                      </p>

                    </div>

                  </div>

                  <p className="footer-description">

                    Enjoy an immersive chess experience with smooth gameplay,
                    beautiful design, and exciting challenges.

                  </p>

                </div>

                <div className="col-lg-4">

                  <h4 className="footer-heading">
                    Quick Links
                  </h4>

                  <ul className="footer-links">

                    <li>
                      <a href="/">Home</a>
                    </li>

                    <li>
                      <a href="/">Features</a>
                    </li>

                    <li>
                      <a href="/">Matches</a>
                    </li>

                    <li>
                      <a href="/">Privacy Policy</a>
                    </li>

                  </ul>

                </div>

                <div className="col-lg-4">

                  <h4 className="footer-heading">
                    Contact
                  </h4>

                  <ul className="footer-contact">

                    <li>Email: newrahulgautam@gmail.com</li>

                    <li>
                      Phone: +91 98XXXX3210
                    </li>

                    <li>India</li>

                  </ul>

                </div>

              </div>

              <div className="copyright-area">
                © 2026 Chess Master | Designed with Dorm Corp ♟️
              </div>

            </div>

          </footer>
        </>
      )}

      {/* CSS */}
      <style>{`

        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700;800&family=Poppins:wght@300;400;500;600;700&display=swap');

        :root {
          --bg-color: #0f172a;
          --card-color: rgba(17, 24, 39, 0.88);
          --border-color: rgba(255, 255, 255, 0.08);
          --text-color: #ffffff;
          --secondary-text: #cbd5e1;
          --accent-color: #3b82f6;
        }

        body {
          margin: 0;
          padding: 0;
          background: var(--bg-color);
          font-family: 'Poppins', sans-serif;
        }

        .home-container {
          min-height: 100vh;
          background:
            radial-gradient(circle at top left, #1e3a8a33, transparent 30%),
            radial-gradient(circle at bottom right, #2563eb22, transparent 30%),
            linear-gradient(135deg, #020617, #0f172a, #111827);
          color: var(--text-color);
          display: flex;
          flex-direction: column;
        }

        /* HEADER */

        .custom-navbar {
          background: rgba(17, 24, 39, 0.95);
          border-bottom: 1px solid var(--border-color);
          backdrop-filter: blur(12px);
          padding-top: 14px;
          padding-bottom: 14px;
        }

        .nav-logo,
        .footer-logo {
          width: 55px;
          height: 55px;
          border-radius: 16px;
          object-fit: cover;
        }

        .brand-title {
          font-family: 'Cinzel', serif;
          font-size: 28px;
          font-weight: 700;
          color: white;
        }

        .brand-subtitle {
          color: var(--secondary-text);
          font-size: 14px;
        }

        .custom-link {
          color: var(--secondary-text) !important;
          transition: 0.3s;
          font-size: 16px;
        }

        .custom-link:hover {
          color: var(--accent-color) !important;
        }

        /* SPLASH */

        .splash-screen {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .logo {
          width: 150px;
          height: 150px;
          border-radius: 30px;
          margin-bottom: 30px;
        }

        .title {
          font-family: 'Cinzel', serif;
          font-size: 55px;
          font-weight: 800;
          margin-bottom: 30px;
        }

        .loading-bar-container {
          width: 320px;
          height: 14px;
          background: rgba(255,255,255,0.1);
          border-radius: 20px;
          overflow: hidden;
        }

        .loading-bar-fill {
          height: 100%;
          background: linear-gradient(
            90deg,
            #2563eb,
            #3b82f6
          );
          transition: width 0.2s;
        }

        .loading-text {
          margin-top: 18px;
          font-size: 18px;
          color: var(--secondary-text);
        }

        /* MAIN */

        .main-content {
          flex: 1;
          max-width: 1300px;
          width: 100%;
          margin: auto;
          padding: 70px 20px;
        }

        /* HERO */

        .hero-section {
          text-align: center;
          margin-bottom: 70px;
        }

        .hero-logo {
          width: 150px;
          height: 150px;
          border-radius: 35px;
          margin-bottom: 30px;
          box-shadow:
            0 0 40px rgba(59,130,246,0.25);
        }

        .hero-title {
          font-family: 'Cinzel', serif;
          font-size: 72px;
          font-weight: 800;
          margin-bottom: 24px;
          text-shadow:
            0 0 10px rgba(59,130,246,0.4);
        }

        .hero-subtitle {
          max-width: 850px;
          margin: auto;
          color: var(--secondary-text);
          font-size: 21px;
          line-height: 2;
        }

        /* SECTION */

        .info-section {
          margin-bottom: 70px;
        }

        .section-card {
          background: var(--card-color);
          border: 1px solid var(--border-color);
          border-radius: 35px;
          padding: 50px;
          backdrop-filter: blur(12px);
          box-shadow:
            0 10px 35px rgba(0,0,0,0.35);
        }

        .section-title {
          font-family: 'Cinzel', serif;
          font-size: 42px;
          font-weight: 700;
          margin-bottom: 30px;
          position: relative;
        }

        .section-title::after {
          content: "";
          width: 120px;
          height: 4px;
          background: var(--accent-color);
          position: absolute;
          left: 0;
          bottom: -12px;
          border-radius: 20px;
        }

        .section-text {
          color: var(--secondary-text);
          font-size: 18px;
          line-height: 2;
        }

        .highlight {
          color: white;
          font-weight: 700;
        }

        /* FEATURES */

        .features-section {
          margin-top: 30px;
        }

        .feature-card {
          background: var(--card-color);
          border: 1px solid var(--border-color);
          border-radius: 32px;
          padding: 40px 35px;
          height: 100%;
          backdrop-filter: blur(12px);
          transition: 0.4s ease;
          box-shadow:
            0 10px 25px rgba(0,0,0,0.25);
        }

        .feature-card:hover {
          transform: translateY(-8px);
          border-color: rgba(59,130,246,0.4);
          box-shadow:
            0 15px 35px rgba(0,0,0,0.4),
            0 0 30px rgba(59,130,246,0.15);
        }

        .feature-icon {
          width: 85px;
          height: 85px;
          border-radius: 24px;
          background: rgba(59,130,246,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 25px;
          color: var(--accent-color);
          font-size: 34px;
        }

        .feature-title {
          font-family: 'Cinzel', serif;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 18px;
        }

        .feature-text {
          color: var(--secondary-text);
          line-height: 1.9;
          font-size: 17px;
        }

        .feature-text strong {
          color: white;
          font-weight: 700;
        }

        /* AD */

        .board-section {
          margin-top: 70px;
        }

        .ad-box {
          background: var(--card-color);
          border: 1px solid var(--border-color);
          border-radius: 30px;
          padding: 30px;
          text-align: center;
        }

        /* FOOTER */

        .custom-footer {
          background: rgba(17, 24, 39, 0.95);
          border-top: 1px solid var(--border-color);
          padding: 70px 0 30px;
          margin-top: 50px;
        }

        .footer-title {
          font-family: 'Cinzel', serif;
          font-size: 28px;
          font-weight: 700;
        }

        .footer-subtitle {
          color: var(--secondary-text);
          font-size: 14px;
        }

        .footer-description {
          color: var(--secondary-text);
          line-height: 1.9;
        }

        .footer-heading {
          font-size: 24px;
          margin-bottom: 24px;
          font-weight: 700;
        }

        .footer-links,
        .footer-contact {
          list-style: none;
          padding: 0;
        }

        .footer-links li,
        .footer-contact li {
          margin-bottom: 16px;
          color: var(--secondary-text);
        }

        .footer-links a {
          color: var(--secondary-text);
          text-decoration: none;
          transition: 0.3s;
        }

        .footer-links a:hover {
          color: var(--accent-color);
        }

        .copyright-area {
          border-top: 1px solid var(--border-color);
          margin-top: 50px;
          padding-top: 24px;
          text-align: center;
          color: var(--secondary-text);
          font-size: 15px;
        }

        /* MOBILE */

        @media (max-width: 992px) {

          .hero-title {
            font-size: 52px;
          }

          .hero-subtitle {
            font-size: 18px;
          }

          .section-title {
            font-size: 34px;
          }

          .feature-title {
            font-size: 24px;
          }

          .section-card,
          .feature-card {
            padding: 30px;
          }

        }

        @media (max-width: 576px) {

          .hero-title {
            font-size: 38px;
          }

          .hero-subtitle {
            font-size: 16px;
            line-height: 1.8;
          }

          .section-title {
            font-size: 28px;
          }

          .section-text,
          .feature-text {
            font-size: 15px;
            line-height: 1.8;
          }

          .feature-title {
            font-size: 22px;
          }

          .feature-icon {
            width: 70px;
            height: 70px;
            font-size: 28px;
          }

          .section-card,
          .feature-card {
            padding: 24px;
            border-radius: 24px;
          }

          .hero-logo,
          .logo {
            width: 120px;
            height: 120px;
          }

          .title {
            font-size: 40px;
          }

          .loading-bar-container {
            width: 260px;
          }

        }

      `}</style>

    </div>
  );
};

export default Home;